export const hungupMsg = {
  0: {
    title: '工单取消挂起',
    content:
      '确认取消工单挂起？取消工单挂起后，进入工单回滚判断逻辑，如达到回滚条件，则系统将工单进行回滚。'
  },
  1: {
    title: '工单挂起',
    content:
      '确定挂起该工单？挂起后将不再受工单逻辑限制回滚，如未取消挂起，则在次日凌晨回滚工单池。'
  }
}
export const batchHungupMsg = {
  0: {
    title: '工单取消全部挂起',
    content:
      '确认取消工单挂起？取消工单挂起后，该医患关系下正在处理的工单全部进入工单回滚判断逻辑，如达到回滚条件，则系统将工单进行回滚。'
  },
  1: {
    title: '工单全部挂起',
    content:
      '确定挂起该医患关系下所有可主动挂起工单？挂起后将不再受工单逻辑限制回滚，如未取消挂起，则在次日凌晨回滚工单池。'
  }
}
